<template lang="pug">
  div.item(:style="pos(pnum,num)")
    figure
      img(:src="imgScr(pnum,num)",:style="imgSty(pnum,num)")
      div.code(v-if="preview === true") {{item.code}}
    div.clothes(v-if="checkClothes()",:data-code="item.code")
      img(:src="'./static/front/clothes.svg'",:style="clothesSty()")
    div.del(v-if="delflg") 削除
    div.cross(v-if="fg")
</template>

<script>
import store from '../../stores/index';
export default {
  name: 'Item',
  data () {
    return {
      fg: false,
      chk: -1,
      mouseflg: false,
      delflg: false,
      itemflg: false,
      item: {},
      $info: {},
      parent: 0,
      child: 0,
      height: 0,
      space: 0,
      hole: 0,
      prev: 0,
      previtem: '',
      $tar: {},
      dragged: {},
      elem: {},
      slits: []
    };
  },
  props: {
    pnum: Number,
    num: Number,
    dat: Object
  },
  computed: {
    infoitem () {
      return this.$store.getters.infoitem;
    }
  },
  watch: {
    number () {
      let me = this;
      me.update(true);
      setTimeout(function () {
        me.update();
        me.slits[me.pnum].item.splice(me.num, 1, me.item);
      }, 100);
    },
    sets () {
      let me = this;
      me.update();
      me.slits[me.pnum].item.splice(me.num, 1, me.item);
    }
  },
  methods: {
    update (f) {
      let me = this;
      f = f || false;
      if (me.sets[me.number] !== undefined) {
        me.set = me.sets[me.number];
        me.slits = me.set.slits;
        me.height = me.c2p(me.set.size[1]);
        if (me.slits !== undefined) {
          me.hole = Number(me.slits[0].slit.hole);
          if (me.prev !== me.chk && me.slits[me.chk] !== undefined) {
            me.space = me.slits[me.chk + 1].pos - me.slits[me.chk].pos;
          } else {
            me.space = me.slits[me.pnum + 1].pos - me.slits[me.pnum].pos;
          }
          let itm = me.slits[me.pnum].item[me.num];
          if (itm.code.includes('KS')) {
            me.space = me.slits[me.pnum].span + me.slits[me.pnum + 1].span;
          }
          const isHasKentakunW75 = me.slits[me.pnum].item.some(item => item.code.includes('KS7560C') || item.code.includes('KS7560MA'));
          const isHasKentakunW60 = me.slits[me.pnum].item.some(item => item.code.includes('KS6060C') || item.code.includes('KS6060MAW'));
          if (itm.ary[me.space] !== undefined && !isHasKentakunW75) {
            me.item = me.acopy(itm.ary[me.space]);
            me.item.display = true;
            me.itemflg = true;
          } else {
            if (me.space > 60) {
              me.item = me.acopy(itm.ary[itm.ary.length - 1]);
            } else {
              if (itm.ary[60] !== undefined) {
                if (me.slits[me.pnum + 1].span === 30 && (isHasKentakunW75 || isHasKentakunW60)) {
                  if (isHasKentakunW75) {
                    me.item = me.acopy(itm.ary[75]); // chec
                  }
                  if (isHasKentakunW60) {
                    me.item = me.acopy(itm.ary[60]); // chec
                  }
                  me.item.display = true;
                  me.itemflg = true;
                } else {
                  const isCheck = me.slits[me.pnum - 1] ? me.slits[me.pnum - 1].item.some(item => item.code.includes('KS')) : false;
                  if (isCheck || itm.ary[me.space] === undefined) {
                    me.item = me.acopy(itm.ary[60]);
                    me.item.display = false;
                  } else {
                    me.item = me.acopy(itm.ary[me.space]);
                  }
                }
              } else {
                me.item = me.acopy(itm.ary[75]);
                me.item.display = true;
                me.itemflg = true;
              }
            }
          }
          me.item.ary = itm.ary;
          me.item.dat = itm.dat;
          me.item.cat = itm.cat;
          me.item.y = itm.y;

          const isCheck = me.slits[me.pnum].item ? me.slits[me.pnum].item.some(item => item.code.includes('KS')) : false;
          if (!me.itemflg && !isCheck) {
            me.item.display = false;
          } else if (!me.itemflg && isCheck) {
            me.item.display = true;
          }
          if (me.hole < me.item.y) {
            me.item.display = false;
          }

          let mm;
          if (me.slits[me.pnum].hasOwnProperty('span')) {
            if (me.slits[me.pnum + 1].hasOwnProperty('span')) {
              mm = itm.w - me.slits[me.pnum + 1].span;
            }
          }
          if (itm.code.includes('KS') || itm.code === 'KMSA') {
            if ((me.space === Number(mm) || me.space === Number(itm.w))) {
              me.itemflg = true;
              me.item.display = true;
            } else {
              me.itemflg = false;
              me.item.display = false;
            }
          }
        }
      }
    },
    pos (i, s) {
      let top;
      let bottom;
      let height;
      let itm = this.slits[i].item[s];
      let checkCabinet = itm.code.substr(0, 3);
      if (checkCabinet === 'HB3') {
        top = '460px';
      } else if (checkCabinet === 'HB4') {
        top = '388px';
      } else {
        top = (itm.y * (this.height / this.hole)) + 'px';
      }
      bottom = 'auto';
      if (this.elem.offsetHeight !== undefined) {
        height = this.elem.offsetHeight + 'px';
      } else {
        height = '';
      }
      return {
        left: '0px',
        width: this.c2p(itm.w) + 'px',
        height: height,
        bottom: bottom,
        top: top
      };
    },
    imgScr (i, s) {
      let itm = this.slits[i].item[s];
      return './static/front/' + itm.code + '.svg';
    },
    imgSty (i, s) {
      let opacity;
      let itm = this.slits[i].item[s];
      if (itm.display) {
        opacity = 1;
      } else {
        opacity = 0.3;
      }
      return {
        opacity: opacity
      };
    },
    clothesSty () {
      return {
        width: this.c2p(120) * 0.35 + 'px',
        height: this.c2p(120) + 'px'
      };
    },
    open (e) {
      let dat = {
        left: this.mp(e).clientX,
        top: this.mp(e).clientY,
        display: true,
        item: this.item
      };
      store.commit('setInfoitem', dat);
      window.addEventListener('mouseout', this.mouseout, false);
      window.addEventListener('touchcancel', this.mouseout, false);
    },
    mouseout () {
      let dat = {
        display: false
      };
      store.commit('setInfoitem', dat);
      window.removeEventListener('mouseup', this.mouseup, false);
      window.removeEventListener('mousemove', this.mousemove, false);
      window.removeEventListener('mouseout', this.mouseout, false);
      window.removeEventListener('touchmove', this.mousemove, false);
      window.removeEventListener('touchcancel', this.mouseout, false);
      window.removeEventListener('touchend', this.mouseup, false);
    },
    mousedown (e) {
      this.update();
      this.prev = this.pnum;
      this.$tar = e.currentTarget;
      this.sX = parseInt(this.$tar.style.left) || 0;
      this.sY = parseInt(this.$tar.style.top) || 0;
      this.startX = this.mp(e).clientX;
      this.startY = this.mp(e).clientY;
      this.flg = true;
      const targetElements = e.target.parentNode.children;
      this.child = Array.from(targetElements).indexOf(e.target);
      const childElements = e.target.parentNode.parentNode.children;
      this.parent = Array.from(childElements).indexOf(e.target.parentNode);
      let ah = (this.height / this.hole);
      this.startPosY = Math.round((this.mp(e).clientY - this.startY + this.sY) / ah);
      window.addEventListener('mousemove', this.mousemove, false);
      window.addEventListener('mouseup', this.mouseup, false);
      window.addEventListener('touchmove', this.mousemove, false);
      window.addEventListener('touchend', this.mouseup, false);
    },
    mousemove (e) {
      let me = this;
      if (me.flg) {
        me.delflg = false;
        me.fg = false;
        me.$tar.classList.add('dragging');
        let ah = (me.height / me.hole);
        me.posY = Math.round((me.mp(e).clientY - me.startY + me.sY) / ah);
        me.chk = me.mouseItems(e); // ドラック要素がどのスリット内か調べる
        if (me.chk === -1) {
          // 削除エリアのとき
          me.delflg = true;
          me.posX = this.mp(e).clientX - me.startX + me.sX;
          me.$tar.style.left = me.posX + 'px';
          if (me.item.flr) {
            me.$tar.style.top = '';
          }
        } else {
          // スリットエリア内のとき
          me.$tar.style.left = '0px';
          if (me.item.flr) {
            me.$tar.style.top = '';
          }
          let tp = me.checkTop(me.item.code);
          if (me.posY * ah < ah * tp) {
            me.posY = tp;
          } else if (me.hole < me.posY + me.item.hole) {
            me.posY = me.hole - me.item.hole;
          }
        }

        if (me.prev !== me.chk && me.chk !== -1) {
          // ドラッグで別のスリットに移動したとき
          let parent = document.querySelector('.items-area .slit:nth-child(' + (me.chk + 1) + ') .items');
          parent.appendChild(me.$tar);
          me.sX = parseInt(me.$tar.style.left) || 0;
          me.startX = this.mp(e).clientX;
          me.update();
        }
        if (me.slits[me.chk]) {
          const isCheck = me.slits[me.chk] ? me.slits[me.chk].item.some(item => item.code.includes('KS')) : false;
          const spaceKentakun = me.slits[me.chk].span + me.slits[me.chk + 1].span;
          if (isCheck && spaceKentakun === me.item.w) {
            me.itemflg = true;
          }
        }
        if (!me.delflg) {
          // 他商品と重なりチェック
          if (me.slits[me.prev] !== undefined) {
            for (let prop in me.slits[me.prev].item) {
              if (Number(me.num) !== Number(prop) || me.prev !== me.pnum) {
                let itm = me.slits[me.prev].item[prop];
                if (me.posY + me.item.hole > itm.y && me.posY < itm.y + itm.hole) {
                  me.fg = true;
                }
              }
            }
          }
          if (document.querySelector('.items-area .slit:nth-child(' + (me.chk + 1) + ') .flr .item')) {
            let floor = document.querySelector('.items-area .slit:nth-child(' + (me.chk + 1) + ') .flr .item');
            if (floor.getBoundingClientRect && floor !== null) {
              if (me.$tar.getBoundingClientRect().bottom >= floor.getBoundingClientRect().top) {
                me.fg = true;
              }
            }
          }
        }
        if (!me.itemflg) {
          me.fg = true;
          // 削除優先
          if (me.delflg) {
            me.fg = false;
          }
        }
        me.item.y = me.posY;
        me.item.display = true;
        if (this.previtem !== JSON.stringify(me.item)) {
          me.slits[me.pnum].item.splice(me.num, 1, me.item);
        }

        // 一つ前を保持
        if (me.chk === -1) {
          me.prev = me.num;
        } else {
          me.prev = me.chk;
        }
        this.previtem = JSON.stringify(me.item);
      }
      if (me.prev !== me.pnum && me.slits[me.chk]) {
        if (me.space === Number(me.item.w) && me.item.code.includes('KS')) {
          me.slits[me.chk].item.find(item => {
            if (item.code.includes('KS')) {
              me.itemflg = false;
            } else {
              me.itemflg = true;
            }
          });
        }
        let mm;
        mm = me.slits[me.chk].span + me.slits[me.chk + 1].span;
        if (me.item.code.includes('KS')) {
          if ((Number(mm) === Number(me.item.w)) && me.slits[me.chk + 1].span === 30) {
            me.itemflg = true;
            me.item.display = true;
          } else {
            me.itemflg = false;
            me.item.display = false;
          }
        }
      }
      me.mouseflg = true;
    },
    mouseup (e) {
      if (!this.infoitem.display && !this.mouseflg) {
        this.open(e);
      } else {
        this.mouseout();
      }
      if (this.mouseflg) {
        this.mouseflg = false;
      }
      window.removeEventListener('mousemove', this.mousemove);
      window.removeEventListener('mouseup', this.mouseup);
      this.$tar.classList.remove('dragging');
      this.parent = 0;
      this.child = 0;
      if (this.fg) {
        this.itemBack();
      } else if (this.delflg) {
        this.prev = this.pnum;
        this.itemDelete();
      } else if (this.prev !== this.pnum) {
        this.itemMove();
      }
      this.flg = false;
      this.fg = false;
    },
    itemMove () {
      let me = this;
      let parent = document.querySelector('.items-area .slit:nth-child(' + (me.pnum + 1) + ') .items');
      parent.appendChild(me.$tar);
      me.item.y = me.posY;
      me.slits[me.pnum].item.splice(me.num, 1, me.item);
      me.slits[me.prev].item.push(me.item);
      me.slits[me.pnum].item.splice(me.num, 1);
      if (me.item.code.includes('KS') && me.prev !== me.pnum) {
        me.slits.splice(me.pnum + 1, 1);
        let mm;
        let rate = me.item.w > 60 ? 2 / 3 : 1 / 2;
        let pos;
        if (me.prev > 1) {
          pos = me.prev;
          mm = (me.slits[me.prev].pos - me.slits[me.prev - 1].pos) * rate + me.slits[me.prev - 1].pos;
        } if (me.pnum > me.prev) {
          pos = me.pnum - me.prev > 1 ? me.pnum - 1 : me.pnum;
          mm = (me.slits[pos].pos - me.slits[pos - 1].pos) * rate + me.slits[pos - 1].pos;
        } else if (me.prev < 1) {
          pos = me.pnum;
          mm = (me.slits[me.pnum].pos + me.slits[me.pnum - 1].pos) * rate;
        }
        let obj = {
          pos: me.item.w > 60 ? mm - 5 : mm,
          item: [],
          floor: [],
          slit: {},
          outRange: false
        };
        me.slits.splice(pos, 0, obj);
        this.updateSlit(this.set);
      }
      setTimeout(function () {
        me.sets.splice(me.number, 1, me.set);
      }, 100);
    },
    itemBack () {
      this.item.y = this.startPosY;
      let parent = document.querySelector('.items-area .slit:nth-child(' + (this.pnum + 1) + ') .items');
      parent.appendChild(this.$tar);
      this.slits[this.pnum].item.splice(this.num, 1, this.item);
      this.sets.splice(this.number, 1, this.set);
    },
    itemDelete () {
      let parent = document.querySelector('.items-area .slit:nth-child(' + (this.pnum + 1) + ') .items');
      parent.appendChild(this.$tar);
      this.$tar.style.left = '0px';
      this.slits[this.pnum].item.splice(this.num, 1);
      this.sets.splice(this.number, 1, this.set);
      if (this.item.code.includes('KS')) this.slits.splice(this.pnum + 1, 1);
      this.delflg = false;
    },
    checkClothes () {
      if (this.clothes === true) {
        let codeLP = this.item.code.substr(0, 3);
        if ((this.item.d === 10 || this.item.d === 15) && codeLP !== 'LPN') {
          return false;
        } else if (this.item.cat === 1 || this.item.cat === 3) {
          return true;
        } else if (this.item.cat === 4) {
          let ty = this.item.code.substr(0, 2);
          if (ty === 'TP' || ty === 'BP') {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    display () {
      if (this.item.code !== undefined) {
        return true;
      } else {
        return false;
      }
    }
  },
  created () {
    this.update(true);
  },
  destroyed () {
    this.$el.removeEventListener('mousedown', this.mousedown);
    this.$el.removeEventListener('touchstart', this.mousedown);
  },
  mounted () {
    if ('ontouchstart' in window) {
      this.$el.addEventListener('touchstart', this.mousedown);
    } else {
      this.$el.addEventListener('mousedown', this.mousedown);
    }
    this.elem = this.$el.querySelector('img');
    if (this.$el.querySelector) {
    }
  }
};
</script>

<style lang="stylus" scoped>
  .item
    width 100%
    height 25px
    position absolute
    left 0
    cursor pointer
    user-select none
    filter drop-shadow(1px 1px 3px rgba(0,0,0,0.2))
    &.dragging
      z-index 1000
    figure
      line-height 0
      position relative
      .code
        //display none
        text-align center
        position absolute
        top 25px
        width 100%
        font-size 14px
        z-index 2
        text-shadow 1px 1px 1px #ffffff,-1px -1px 1px #ffffff,-1px 1px 1px #ffffff,1px -1px 1px #ffffff,1px 0px 1px #ffffff,-1px 0px 1px #ffffff,0px 1px 1px #ffffff,0 -1px 1px #ffffff
        //.preview &
        //  display block
    img
      width 100%
      pointer-events none
  .cross
    display flex
    justify-content center
    align-items center
    width 20px
    height 20px
    background-color #cc0000
    color #ffffff
    line-height 1
    border-radius 50%
    position absolute
    left 50%
    top 0
    transform translate(-50%, 0)
    &:before
      content ""
      display block
      width 10px
      height 2px
      background-color #ffffff
      position absolute
      left 50%
      top 50%
      transform translate(-50%,-50%) rotate(45deg)
    &:after
      content ""
      display block
      width 10px
      height 2px
      background-color #ffffff
      position absolute
      left 50%
      top 50%
      transform translate(-50%,-50%) rotate(-45deg)
  .del
    position absolute
    left 50%
    transform translate(-50%,0)
    padding 5px 10px
    font-size 12px
    top -40px
    color #ffffff
    white-space nowrap
    border-radius 3px
    background-color #000000cc
  .clothes
    margin-top -15px
    pointer-events none
    user-select none
    text-align center
    img
      height 240px
    &[data-code="TP4560E"],
    &[data-code="TP6060E"],
    &[data-code="TP7560E"],
    &[data-code="TP9060E"],
    &[data-code="TP4560M3W"],
    &[data-code="TP6060M3W"],
    &[data-code="TP7560M3W"],
    &[data-code="TP9060M3W"],
    &[data-code="TP4560M3B"],
    &[data-code="TP6060M3B"],
    &[data-code="TP7560M3B"],
    &[data-code="TP9060M3B"]
      margin-top -30px
    &[data-code="LD4527E"],
    &[data-code="LD6027E"],
    &[data-code="LD7527E"],
    &[data-code="LD9027E"],
    &[data-code="LD4530E"],
    &[data-code="LD6030E"],
    &[data-code="LD7530E"],
    &[data-code="LD9030E"],
    &[data-code="LD4530M3W"],
    &[data-code="LD6030M3W"],
    &[data-code="LD7530M3W"],
    &[data-code="LD9030M3W"],
    &[data-code="LD4530M3B"],
    &[data-code="LD6030M3B"],
    &[data-code="LD7530M3B"],
    &[data-code="LD9030M3B"]
      margin-top -40px
    &[data-code="WPN45-E"],
    &[data-code="WPN60-E"],
    &[data-code="WPN75-E"],
    &[data-code="WPN90-E"]
      margin-top -43px
    &[data-code="BPN45-E"],
    &[data-code="BPN60-E"],
    &[data-code="BPN75-E"],
    &[data-code="BPN90-E"]
      margin-top -29px
    &[data-code="LPN45-E"],
    &[data-code="LPN60-E"],
    &[data-code="LPN75-E"],
    &[data-code="LPN90-E"]
      margin-top -29px
    &[data-code="BPN45GE"],
    &[data-code="BPN60GE"],
    &[data-code="BPN75GE"],
    &[data-code="BPN90GE"]
      margin-top -27px
    &[data-code="BPN45-EBK"],
    &[data-code="BPN60-EBK"],
    &[data-code="BPN75-EBK"],
    &[data-code="BPN90-EBK"]
      margin-top -28px
    &[data-code="WPN45-EBK"],
    &[data-code="WPN60-EBK"],
    &[data-code="WPN75-EBK"],
    &[data-code="WPN90-EBK"],
    &[data-code="LPN45-EBK"],
    &[data-code="LPN60-EBK"],
    &[data-code="LPN75-EBK"],
    &[data-code="LPN90-EBK"]
      margin-top -29px

</style>



// WEBPACK FOOTER //
// src/components/front/Item.vue